var _circle, _rect, _path, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _g2, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _mask, _g3, _circle2, _g4, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _path2, _path3, _path4, _circle3, _circle4, _path5, _rect64, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWelcomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#E5E8F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.8872,
    y: 21.1641,
    width: 3,
    height: 48.4737,
    rx: 1.5,
    transform: "rotate(-9.02329 63.8872 21.1641)",
    fill: "#8C9EB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.625 58.3594C52.8636 58.3594 50.625 60.598 50.625 63.3594V74.6094V114.531V123.672C50.625 126.433 52.8636 128.672 55.625 128.672H127.616C130.482 128.672 132.762 126.267 132.608 123.404L129.98 74.3419C129.838 71.6882 127.645 69.6094 124.987 69.6094H103.319L102.003 62.455C101.567 60.0822 99.4983 58.3594 97.0857 58.3594H76.9219H55.625Z",
    fill: "#16497A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6874 45.9693C73.9933 43.2248 76.466 41.248 79.2104 41.5538L91.5857 42.9329L107.374 44.6923C110.118 44.9981 112.095 47.4709 111.789 50.2153L106.971 93.4519C106.665 96.1963 104.192 98.1732 101.448 97.8673L73.2846 94.7288C70.5402 94.423 68.5633 91.9503 68.8692 89.2058L73.6874 45.9693Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9801,
    y: 56.5337,
    width: 13.324,
    height: 10.3749,
    rx: 2.5,
    transform: "rotate(6.35878 75.9801 56.5337)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0859,
    y: 69.0151,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 74.0859 69.0151)",
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103.82,
    y: 72.2764,
    width: 1.68517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 103.82 72.2764)",
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 102.513,
    y: 84.0002,
    width: 1.68517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 102.513 84.0002)",
    fill: "#DFDFDF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 103.166,
    y: 78.1387,
    width: 1.68517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 103.166 78.1387)",
    fill: "#DFDFDF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 101.813,
    y: 90.281,
    width: 1.68517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 101.813 90.281)",
    fill: "#DFDFDF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 103.494,
    y: 75.1997,
    width: 1.68517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 103.494 75.1997)",
    fill: "#DFDFDF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 102.187,
    y: 86.9238,
    width: 1.68517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 102.187 86.9238)",
    fill: "#DFDFDF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 102.84,
    y: 81.0618,
    width: 1.68517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 102.84 81.0618)",
    fill: "#DFDFDF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 101.487,
    y: 93.209,
    width: 1.68517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 101.487 93.209)",
    fill: "#DFDFDF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4336,
    y: 74.8691,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 73.4336 74.8691)",
    fill: "#DFDFDF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 72.7808,
    y: 80.7312,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 72.7808 80.7312)",
    fill: "#DFDFDF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 72.0801,
    y: 87.0115,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 72.0801 87.0115)",
    fill: "#DFDFDF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 73.7598,
    y: 71.9382,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 73.7598 71.9382)",
    fill: "#DFDFDF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1084,
    y: 77.7925,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 73.1084 77.7925)",
    fill: "#DFDFDF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 72.4551,
    y: 83.6541,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 72.4551 83.6541)",
    fill: "#DFDFDF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7534,
    y: 89.9429,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.26215 71.7534 89.9429)",
    fill: "#DFDFDF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 76.8916,
    y: 43.8389,
    width: 32.4396,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.35878 76.8916 43.8389)",
    fill: "#D3DFEA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5654,
    y: 46.7695,
    width: 32.4396,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.35878 76.5654 46.7695)",
    fill: "#D3DFEA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 76.2388,
    y: 49.7004,
    width: 32.4396,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.35878 76.2388 49.7004)",
    fill: "#D3DFEA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9116,
    y: 52.6313,
    width: 29.4905,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.35878 75.9116 52.6313)",
    fill: "#D3DFEA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 90.7969,
    y: 59.8013,
    width: 16.4304,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.35878 90.7969 59.8013)",
    fill: "#DFDFDF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4702,
    y: 62.7322,
    width: 16.4304,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.35878 90.4702 62.7322)",
    fill: "#DFDFDF"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 90.144,
    y: 65.6628,
    width: 14.7453,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(6.35878 90.144 65.6628)",
    fill: "#DFDFDF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6712 60.3639C55.3005 57.6275 57.2183 55.1087 59.9547 54.738L72.2938 53.0664L88.0359 50.9338C90.7723 50.5631 93.2912 52.4809 93.6619 55.2173L99.5021 98.3277C99.8728 101.064 97.955 103.583 95.2186 103.954L67.1374 107.758C64.401 108.129 61.8822 106.211 61.5115 103.474L55.6712 60.3639Z",
    fill: "white"
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0439,
    y: 70.6707,
    width: 32.4396,
    height: 8.42586,
    rx: 3,
    transform: "rotate(-7.71497 60.0439 70.6707)",
    fill: "#D3DFEA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 81.6397,
    y: 91.4181,
    width: 13.324,
    height: 10.3749,
    rx: 2.5,
    transform: "rotate(-7.71497 81.6397 91.4181)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8471,
    y: 80.8407,
    width: 31.597,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(-7.71497 61.8471 80.8407)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 63.6567,
    y: 94.1998,
    width: 15.5878,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(-7.71497 63.6567 94.1998)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2426,
    y: 83.763,
    width: 31.597,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(-7.71497 62.2426 83.763)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 64.0522,
    y: 97.1222,
    width: 15.5878,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(-7.71497 64.0522 97.1222)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 62.6381,
    y: 86.6854,
    width: 31.597,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(-7.71497 62.6381 86.6854)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4472,
    y: 100.045,
    width: 15.5878,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(-7.71497 64.4472 100.045)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 64.8442,
    y: 102.967,
    width: 10.111,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(-7.71497 64.8442 102.967)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0346,
    y: 89.6077,
    width: 15.5878,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(-7.71497 63.0346 89.6077)",
    fill: "#DFDFDF",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 58.2622,
    y: 58.5679,
    width: 14.2713,
    height: 11.2132,
    rx: 3,
    transform: "rotate(-7.71497 58.2622 58.5679)",
    fill: "#BACBDB"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 73.9922,
    y: 57.9836,
    width: 16.4304,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(-7.71497 73.9922 57.9836)",
    fill: "#D3DFEA"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 74.3877,
    y: 60.906,
    width: 16.4304,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(-7.71497 74.3877 60.906)",
    fill: "#D3DFEA"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7842,
    y: 63.8284,
    width: 14.7453,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(-7.71497 74.7842 63.8284)",
    fill: "#D3DFEA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 57,
    width: 16,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6288 61.5197C58.4064 59.8779 59.5571 58.3666 61.1989 58.1441L69.3954 57.0338C71.0372 56.8113 72.5485 57.962 72.7709 59.6039L73.4708 64.7698C73.6932 66.4117 72.5425 67.923 70.9007 68.1454L62.7042 69.2558C61.0624 69.4782 59.5511 68.3276 59.3287 66.6857L58.6288 61.5197Z",
    fill: "#F9FAFB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2957 63.4999C61.8823 65.2843 60.1771 67.4633 59.5376 68.3652C59.3563 68.6209 59.304 68.926 59.346 69.2366L59.4317 69.8689C59.58 70.9635 60.5875 71.7306 61.6821 71.5823L73.3162 70.0062C74.4108 69.858 75.1779 68.8504 75.0296 67.7559L74.8526 66.4494C74.7809 65.9201 74.5005 65.4415 74.0738 65.1202L72.7359 64.1127C72.0173 63.5716 70.9969 63.7098 70.4482 64.4227C69.8994 65.1355 68.8791 65.2737 68.1605 64.7326L66.0571 63.1487C65.1927 62.4978 63.9676 62.6516 63.2957 63.4999Z",
    fill: "#6DB7FF"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.0388,
    cy: 59.6589,
    r: 1.26388,
    transform: "rotate(-7.71497 69.0388 59.6589)",
    fill: "#6DB7FF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8114 59.7725C89.418 57.0785 92.0936 55.3863 94.7876 55.9928L106.935 58.7279L122.433 62.2172C125.127 62.8237 126.819 65.4993 126.213 68.1933L116.657 110.635C116.051 113.329 113.375 115.021 110.681 114.415L83.0353 108.19C80.3413 107.584 78.6491 104.908 79.2557 102.214L88.8114 59.7725Z",
    fill: "white"
  }))), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 90.7378,
    y: 85.7415,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 90.7378 85.7415)",
    fill: "#DFDFDF"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3481,
    y: 97.4646,
    width: 32.0183,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 83.3481 97.4646)",
    fill: "#DFDFDF"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 96.6465,
    y: 59.4993,
    width: 16.8517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 96.6465 59.4993)",
    fill: "#D3DFEA"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5353,
    y: 85.2272,
    width: 0.842586,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(12.6885 86.5353 85.2272)",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 92.4581,
    y: 58.9225,
    width: 0.842586,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(12.6885 92.4581 58.9225)",
    stroke: "#6DB7FF",
    strokeWidth: 0.842586
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8873,
    y: 88.1044,
    width: 0.842586,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(12.6885 85.8873 88.1044)",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8102,
    y: 61.7999,
    width: 0.842586,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(12.6885 91.8102 61.7999)",
    stroke: "#6DB7FF",
    strokeWidth: 0.842586
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 85.2399,
    y: 90.9811,
    width: 0.842586,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(12.6885 85.2399 90.9811)",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 91.1622,
    y: 64.6766,
    width: 0.842586,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(12.6885 91.1622 64.6766)",
    stroke: "#6DB7FF",
    strokeWidth: 0.842586
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 84.5919,
    y: 93.8585,
    width: 0.842586,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(12.6885 84.5919 93.8585)",
    stroke: "#DFDFDF",
    strokeWidth: 0.842586
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 90.5148,
    y: 67.5538,
    width: 0.842586,
    height: 0.842586,
    rx: 0.421293,
    transform: "rotate(12.6885 90.5148 67.5538)",
    stroke: "#6DB7FF",
    strokeWidth: 0.842586
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0938,
    y: 85.3711,
    width: 0.421293,
    height: 10.5323,
    rx: 0.210647,
    transform: "rotate(12.6885 89.0938 85.3711)",
    fill: "#C4C4C4"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0166,
    y: 59.0671,
    width: 0.421293,
    height: 10.5323,
    rx: 0.210647,
    transform: "rotate(12.6885 95.0166 59.0671)",
    fill: "#8C9EB2"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 90.0898,
    y: 88.6184,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 90.0898 88.6184)",
    fill: "#DFDFDF"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 82.7007,
    y: 100.342,
    width: 32.0183,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 82.7007 100.342)",
    fill: "#DFDFDF"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 96.0122,
    y: 62.3145,
    width: 16.8517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 96.0122 62.3145)",
    fill: "#D3DFEA"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 89.4424,
    y: 91.4954,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 89.4424 91.4954)",
    fill: "#DFDFDF"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 82.0522,
    y: 103.219,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 82.0522 103.219)",
    fill: "#DFDFDF"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 95.3647,
    y: 65.1909,
    width: 16.8517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 95.3647 65.1909)",
    fill: "#D3DFEA"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 88.7949,
    y: 94.3728,
    width: 27.8053,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 88.7949 94.3728)",
    fill: "#DFDFDF"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7168,
    y: 68.0684,
    width: 16.8517,
    height: 1.68517,
    rx: 0.842586,
    transform: "rotate(12.6885 94.7168 68.0684)",
    fill: "#D3DFEA"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 88.4131,
    y: 75.9314,
    width: 31.6007,
    height: 2.03876,
    rx: 1,
    transform: "rotate(12.6885 88.4131 75.9314)",
    fill: "#D3DFEA"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0854,
    y: 72.9478,
    width: 31.6007,
    height: 2.03876,
    rx: 1,
    transform: "rotate(12.6885 89.0854 72.9478)",
    fill: "#D3DFEA"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 87.7417,
    y: 78.9148,
    width: 28.5426,
    height: 2.03876,
    rx: 1,
    transform: "rotate(12.6885 87.7417 78.9148)",
    fill: "#D3DFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.763 64.8435C118.763 64.8435 118.763 64.8435 118.763 64.8436L117.811 69.072C117.774 69.2336 117.876 69.3941 118.037 69.4305L122.266 70.3825C122.266 70.3825 122.266 70.3825 122.266 70.3825C122.828 67.8856 121.26 65.4057 118.763 64.8435Z",
    fill: "#138BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.868 65.9377C117.869 65.9377 117.869 65.938 117.869 65.9382L117.056 69.5494C117.019 69.7111 117.121 69.8716 117.282 69.908L120.894 70.7211C120.894 70.7211 120.894 70.7212 120.894 70.7213C120.408 72.8778 118.267 74.2323 116.11 73.7468C113.954 73.2613 112.599 71.1196 113.085 68.9631C113.57 66.8067 115.712 65.4522 117.868 65.9377Z",
    fill: "#138BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1094 68.2031C49.348 68.2031 47.1094 70.4417 47.1094 73.2031V80.9375V128.594V135.625C47.1094 138.386 49.348 140.625 52.1094 140.625H127.891C130.652 140.625 132.891 138.386 132.891 135.625V80.9375C132.891 78.1761 130.652 75.9375 127.891 75.9375H103.783L102.864 72.0521C102.33 69.7963 100.316 68.2031 97.9979 68.2031H76.9922H52.1094Z",
    fill: "#138BFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5406,
    cy: 100.041,
    r: 3.7125,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.053,
    cy: 100.041,
    r: 3.7125,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0781 113.906C87.8043 116.719 91.4926 116.719 94.2187 113.906",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 38.687,
    y: 28.8765,
    width: 54.3247,
    height: 17.0523,
    rx: 1,
    transform: "rotate(-9.40426 38.687 28.8765)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6592 32.3896L53.8126 38.4071L52.7426 38.5808L50.9616 35.0243C50.9346 34.9746 50.9068 34.9197 50.8781 34.8595C50.8495 34.7993 50.8214 34.735 50.7941 34.6665C50.7899 34.7401 50.7836 34.81 50.7755 34.8762C50.7673 34.9423 50.7583 35.0032 50.7484 35.0589L50.1723 38.9981L49.0984 39.1725L46.3954 33.7314L47.3904 33.5698C47.493 33.5531 47.5824 33.5629 47.6585 33.5992C47.7373 33.6351 47.7936 33.6907 47.8275 33.7663L49.2403 36.8518C49.2758 36.9378 49.3127 37.0318 49.3509 37.1337C49.3912 37.2325 49.4313 37.3381 49.4712 37.4505C49.4757 37.3282 49.4827 37.2136 49.4924 37.1066C49.502 36.9997 49.5154 36.8989 49.5324 36.8043L50.0425 33.4066C50.0529 33.3374 50.088 33.2709 50.1479 33.2072C50.21 33.1404 50.291 33.0988 50.3911 33.0826L50.7385 33.0262C50.8412 33.0095 50.9281 33.0211 50.9994 33.0608C51.0729 33.0975 51.1317 33.1515 51.1756 33.2227L52.7305 36.285C52.7758 36.3641 52.8197 36.4516 52.8623 36.5473C52.9044 36.6404 52.9463 36.7404 52.9879 36.8471C52.9911 36.7331 52.9939 36.6259 52.9965 36.5255C53.0013 36.4221 53.0074 36.3265 53.0148 36.2389L53.3788 32.8649C53.3861 32.7935 53.421 32.7257 53.4835 32.6615C53.5461 32.5973 53.6273 32.5571 53.7274 32.5409L54.6592 32.3896ZM56.6467 33.0192L56.8858 34.4919L58.7968 34.1816L58.9423 35.0779L57.0313 35.3882L57.2756 36.8925L59.7314 36.4937L59.8821 37.4216L56.2339 38.0139L55.3037 32.2849L58.9519 31.6926L59.1025 32.6204L56.6467 33.0192ZM64.0113 35.7623L64.1677 36.7257L60.7682 37.2777L59.838 31.5487L61.0225 31.3564L61.7963 36.122L64.0113 35.7623ZM68.3886 34.5937C68.4544 34.583 68.5135 34.5977 68.5659 34.6378L69.1172 35.063C68.9334 35.3954 68.6815 35.6659 68.3615 35.8746C68.0441 36.0828 67.6485 36.2254 67.1747 36.3023C66.7457 36.372 66.3483 36.3622 65.9826 36.273C65.6165 36.1812 65.2925 36.0244 65.0107 35.8027C64.7288 35.581 64.4944 35.3016 64.3073 34.9646C64.1202 34.6276 63.9922 34.2471 63.9234 33.8234C63.8772 33.5391 63.8637 33.2644 63.8828 32.9992C63.9041 32.731 63.9564 32.4794 64.0398 32.2443C64.1232 32.0092 64.2337 31.7914 64.3714 31.5907C64.5116 31.3896 64.6772 31.2115 64.8681 31.0562C65.0586 30.8983 65.2724 30.7677 65.5096 30.6643C65.749 30.5579 66.0095 30.4818 66.2911 30.4361C66.5017 30.4019 66.7034 30.3881 66.8963 30.3946C67.0918 30.4007 67.2765 30.4234 67.4504 30.4627C67.6242 30.502 67.7873 30.5579 67.9396 30.6304C68.094 30.6999 68.2355 30.7809 68.364 30.8735L68.0537 31.4832C68.0356 31.5212 68.0102 31.5564 67.9777 31.5887C67.9451 31.621 67.8972 31.6423 67.834 31.6526C67.7709 31.6628 67.7027 31.6509 67.6297 31.6168C67.5592 31.5824 67.4721 31.5452 67.3684 31.5053C67.2673 31.465 67.1421 31.434 66.9926 31.4123C66.8459 31.3902 66.6646 31.3967 66.4487 31.4317C66.2092 31.4706 65.9965 31.5497 65.8105 31.6691C65.6246 31.7884 65.4727 31.9428 65.3548 32.1321C65.2392 32.3184 65.1613 32.5377 65.1213 32.79C65.0812 33.0424 65.0859 33.3212 65.1355 33.6266C65.1855 33.9345 65.2723 34.2027 65.3958 34.4312C65.5216 34.6567 65.6716 34.8403 65.846 34.9822C66.0229 35.1237 66.2172 35.2218 66.4287 35.2766C66.6424 35.3284 66.8625 35.3359 67.0888 35.2991C67.2231 35.2773 67.3431 35.2511 67.4489 35.2204C67.5573 35.1893 67.655 35.1505 67.742 35.1039C67.8316 35.0569 67.9132 35.0018 67.9866 34.9386C68.0628 34.8749 68.1367 34.798 68.2086 34.708C68.2337 34.6796 68.2607 34.655 68.2898 34.6341C68.3188 34.6131 68.3517 34.5997 68.3886 34.5937ZM74.8685 32.0462C74.9364 32.4648 74.9284 32.8645 74.8444 33.2456C74.763 33.6262 74.6145 33.9678 74.3989 34.2703C74.1859 34.5723 73.9112 34.8276 73.575 35.0362C73.2383 35.2422 72.8502 35.3808 72.4106 35.4522C71.971 35.5236 71.559 35.5148 71.1744 35.426C70.7894 35.3345 70.4468 35.1794 70.1465 34.9607C69.8463 34.742 69.596 34.4652 69.3958 34.1303C69.1981 33.795 69.0653 33.418 68.9974 32.9995C68.9294 32.581 68.9364 32.1827 69.0182 31.8047C69.1022 31.4237 69.252 31.0819 69.4677 30.7794C69.6833 30.477 69.9595 30.2228 70.2961 30.0168C70.6324 29.8082 71.0203 29.6682 71.4599 29.5969C71.8995 29.5255 72.3117 29.5356 72.6967 29.627C73.0812 29.7159 73.4225 29.8712 73.7206 30.093C74.0209 30.3117 74.2698 30.5887 74.4675 30.924C74.6673 31.2563 74.801 31.6303 74.8685 32.0462ZM73.6564 32.243C73.6076 31.943 73.5246 31.6809 73.4071 31.4568C73.2893 31.2301 73.1419 31.046 72.9649 30.9046C72.7902 30.76 72.5891 30.6617 72.3618 30.6094C72.1367 30.5541 71.8899 30.5482 71.6214 30.5918C71.3529 30.6354 71.1194 30.7193 70.9207 30.8434C70.7216 30.9649 70.5607 31.122 70.438 31.3149C70.3175 31.5046 70.2372 31.7257 70.1972 31.978C70.1567 32.2277 70.1608 32.5026 70.2095 32.8027C70.2587 33.1054 70.3422 33.3701 70.46 33.5968C70.5774 33.8209 70.7233 34.0039 70.8977 34.1458C71.0746 34.2872 71.277 34.3854 71.5047 34.4403C71.732 34.4925 71.9799 34.4969 72.2484 34.4533C72.5169 34.4097 72.7494 34.3274 72.9458 34.2063C73.1445 34.0822 73.3041 33.9253 73.4246 33.7355C73.5477 33.5453 73.6295 33.3253 73.67 33.0756C73.7101 32.8233 73.7055 32.5457 73.6564 32.243ZM81.586 28.0175L82.5162 33.7465L81.4699 33.9164L80.8987 30.3985C80.8868 30.3248 80.8753 30.2456 80.8642 30.1609C80.8558 30.0759 80.8498 29.989 80.8462 29.9005L79.7122 33.2738C79.6505 33.4594 79.5262 33.5674 79.3393 33.5978L79.1735 33.6247C79.0814 33.6396 78.9963 33.6318 78.9184 33.6013C78.8401 33.5681 78.773 33.5128 78.7173 33.4354L76.5644 30.5835C76.5872 30.6744 76.6083 30.7628 76.6277 30.8488C76.6466 30.9322 76.6621 31.0107 76.6741 31.0844L77.2453 34.6024L76.199 34.7722L75.2688 29.0433L76.169 28.8971C76.219 28.889 76.2639 28.883 76.3039 28.8793C76.3438 28.8755 76.3793 28.8778 76.4104 28.8863C76.4437 28.8917 76.4743 28.9056 76.5022 28.9281C76.5324 28.9475 76.563 28.9777 76.5939 29.0186L78.6931 31.8143C78.7581 31.8983 78.8195 31.9856 78.8775 32.0761C78.938 32.1662 78.9964 32.2594 79.0525 32.3557C79.0749 32.244 79.0991 32.1347 79.1249 32.0278C79.1534 31.9205 79.1852 31.8168 79.2203 31.7165L80.3172 28.414C80.3336 28.3654 80.353 28.3272 80.3755 28.2992C80.3976 28.2686 80.4222 28.2457 80.4495 28.2305C80.4789 28.2122 80.5118 28.1987 80.5483 28.1901C80.5873 28.1811 80.6332 28.1723 80.6858 28.1637L81.586 28.0175ZM84.1228 28.558L84.3619 30.0307L86.2729 29.7204L86.4184 30.6167L84.5075 30.9269L84.7517 32.4312L87.2075 32.0325L87.3582 32.9603L83.71 33.5527L82.7798 27.8237L86.428 27.2314L86.5786 28.1592L84.1228 28.558Z",
    fill: "#138BFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 66.8379,
    y: 39.5227,
    width: 46.9825,
    height: 60.3759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 53.6255,
    y: 48.8879,
    width: 47.9226,
    height: 60.9158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 77.1323,
    y: 53.8696,
    width: 51.2035,
    height: 62.6683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIcon);
export default __webpack_public_path__ + "static/media/welcome_icon.69ad89fe.svg";
export { ForwardRef as ReactComponent };